import { STUDENT_PRE_CHECK_STATUS } from "../constants";

export default function isDoneChecking(requiredChecks, currentState){
    return requiredChecks.every(
        item => currentState.studentPreChecks.contextStates.checks[item] === STUDENT_PRE_CHECK_STATUS.success
    )
}